//风险处理页面
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { theme, Image as AntImage, Button, Badge, Modal, Input, Image, Empty, Card, Form, Spin, App, Tag, Tree, Space, Drawer, Upload } from 'antd';
import { ArrowLeftOutlined, PlusOutlined, UserAddOutlined, UserSwitchOutlined, SearchOutlined } from '@ant-design/icons';
import { GetRiskDisposePic, GetRiskImgInfo, getHandlerListFun, AllocationUser, AllocationUserFun, IgnorePointFun, stageFillFun, uploadImageFun } from '@/server/risk'
import hourglass from '@/common/img/risk/hourglass.svg'
import { basicPath } from '@/router/config';//引入路由基础路径
import imgError from '@/component/ImageCom/loading_error.svg'
import { transformGCJ2WGS } from "@/common/js/common.js" //引入公共方法

const { TextArea } = Input;

function ConventionalRisksHandle (props) {
  const location = useLocation();//接受传值数据
  const navigate = useNavigate();//路由跳转
  const { message } = App.useApp();

  const state = location.state;
  const token = localStorage.getItem('dock_token');
  const companyId = localStorage.getItem('dock_CompanyID');
  const {
    token: {
      colorText,
      colorTextTertiary,
      colorBorderSecondary,
      colorTextPlaceholder,
    },
  } = theme.useToken(); //获取主题颜色
  const [loading, setLoading] = useState(true);//

  const [lineName, setLineName] = useState('航线名称')
  const [pointOrder, setPointOrder] = useState('');//编号
  const [visible, setVisible] = useState(false);//是否显示大图

  const [insIdDataList, setInsIdDataList] = useState([])//insId的数据列表
  const [infoDataList, setInfoDataList] = useState({})//根据pointId传的的数据列表
  const [currentIndex, setCurrentIndex] = useState(0)//当前infoDataList在insIdDataList数组中的下标
  const [insIdDataListIds, setInsIdDataListIds] = useState([]);

  const [searchUser, setSearchUser] = useState('');//
  const [showImgInfo, setShowImgInfo] = useState({ //显示图片信息
    visible: false,
    current: 1,
    url1: '',
    url2: '',
    url3: '',
  });

  const [lineInfo, setLineInfo] = useState({
    id: '',
    longitude: '', //经度
    latitude: '', //纬度
    picUrl: '',//图片地址
    address: '',//地址
    date: '',//日期
    pointOrder: '',//图片序号
    divrisk: [],//风险初判
    userName: [],//处理人员
    userIds: [],//处理人员Id
    advice: [],//处理意见
    pointState: '',//风险状态
  });
  const [riskStatus, setRiskStatus] = useState(0);//风险状态
  const [disable, setDisable] = useState(true);
  const [chooseFile, setChooseFile] = useState([]);//选择的文件

  const [openParentKey, setOpenParentKey] = useState([]);//展开的父级
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedData, setSelectedData] = useState([]);//选择的信息 - 为了获取名字
  const [treeData, setTreeData] = useState([]);


  //
  const is_handle = state.is_handle;//是否处理风险
  const [handleForm] = Form.useForm();//分配人员表单
  const [drawerHandleOpen, setDrawerHandleOpen] = useState(false);//
  const [drawerHandleLoading, setDrawerHandleLoading] = useState(false);
  const statusRef = useState(0);//提交的阶段填报状态



  const [drawerOpen, setDrawerOpen] = useState(false);//处理人员
  const [drawerLoading, setDrawerLoading] = useState(false)


  //获取风险节点 handler_status 风险范围 0 全部 1 待处理 2 已处理 3 已忽略(后台)  4 已忽略(web、小程序) 
  const GetRiskDisposePicFun = async () => {
    setLoading(true)
    let params = {
      access_token: token,
      statid: state.statid,
      insIds: state.insIds,
      abnormal_type: state.abnormal_type,
      handler_status: state.handler_status,
    }
    let res = await GetRiskDisposePic(params);
    if (res.ret === 200 && res.data.list) {
      let arr = []
      res.data.list.forEach(ele => {
        arr.push(
          {
            statid: ele.statid,
            pointId: ele.pointId,
            lineName: ele.line_name,
            point_order: ele.point_order
          }
        )
      });
      setInsIdDataListIds([...arr]);
      setInsIdDataList([...res.data.list]);
      let idx = currentIndex;
      if (idx >= arr.length) {
        idx -= 1;
      }
      setCurrentIndex(idx);
      if (arr.length === 0) {
        message.warning('数据跑丢了，即将返回');
        setTimeout(() => {
          switch (state.transfer.urlType) {
            case 1:
              navigate('/routine_risk_conduit', { state: { search: state.transfer } });
              break;
            case 7:
              navigate('/routine_risk_powerGrid', { state: { search: state.transfer } });
              break;
            case 8:
              navigate('/fixedPoint_risk_electricTower', { state: { search: state.transfer } });
              break;
            case 9:
              navigate('/fixedPoint_risk_station', { state: { search: state.transfer } });
              break;

            default:
              break;
          }
        }, 1000)
      }
      await getInfoByPoint(arr[idx]);
      setPointOrder(arr[idx].point_order);
      setLineName(arr[idx].lineName);
      setLoading(false);
    } else {
      message.warning(res.msg || '服务器开了小差，请重试');
      setLoading(false)
    }
  }

  //显示图片
  const showImg = (cur, data = '') => {
    let info = { ...showImgInfo };
    info.visible = true;
    if (data) { //多个图片
      info.current = cur;
      info.urls = data.detail_pic ? data.detail_pic : [];

    } else { //单个图片
      info.urls = [cur];
      info.current = 0;
    }
    setShowImgInfo(info);
  }

  const getInfoByPoint = async (list) => {
    setLoading(true)
    let obj = {
      access_token: token,
      statid: list.statid,
      pointId: list.pointId,
    }
    let res = await GetRiskImgInfo(obj);
    setLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      return;
    }

    let val = res.data;
    console.log('---', val);
    let info = { ...lineInfo };
    info.id = val.pointId;
    info.longitude = Number(val.longitude);
    info.latitude = Number(val.latitude);
    info.divrisk = val.abnormal_type_str ? val.abnormal_type_str.split(",") : [];
    info.address = val.location;
    info.date = val.addtime;
    info.picUrl = val.picUrl;
    info.userName = val.handler_user_name ? val.handler_user_name.split(",") : [];
    info.pointState = Number(val.handler_status);
    info.userIds = val.handler_user ? val.handler_user : [];

    if (info.pointState === 3 || info.pointState === 4) {
      info.advice = (
        <div>
          <Tag
            style={{
              background: "#262626",
              borderRadius: 3,
            }}
            className='marB4'
          >
            已忽略
          </Tag>
          <div style={{ color: colorTextTertiary }}>{val.IgnoreInfo || ''}</div>
        </div>
      )
    } else {
      if (val.list.length > 0) {
        setRiskStatus(0);
        info.advice = val.list.map((item, i) => {
          let imgs = item.detail_pic ? item.detail_pic : [];
          let detailList = item.detail ? item.detail.split('\n') : [];
          if (item.status === 1) {
            setRiskStatus(1);
          }

          return (
            <div className='margB12' key={i}>
              <div className='flex_row'>
                <Tag style={{
                  background: "#262626", borderRadius: 3,
                  display: (item.status === 1) ? 'block' : 'none'
                }} className='marB4'>处理完毕</Tag>
              </div>
              <div className='flex_row' style={{ display: imgs.length > 0 ? '' : 'none' }}>
                <img alt='处理拍照1' src={imgs[0] ? imgs[0] : ''} className='w64 h64 marR8 pointer radius8' style={{ width: 64, objectFit: 'cover', display: imgs[0] ? '' : 'none' }}
                  onClick={() => { showImg(0, item) }}>
                </img>
                <img alt='处理拍照2' src={imgs[1] ? imgs[1] : ''} className='w64 h64 marR8 pointer radius8' style={{ width: 64, objectFit: 'cover', display: imgs[1] ? '' : 'none' }}
                  onClick={() => { showImg(1, item) }}>
                </img>
                <img alt='处理拍照3' src={imgs[2] ? imgs[2] : ''} className='w64 h64 pointer radius8' style={{ width: 64, objectFit: 'cover', display: imgs[2] ? '' : 'none' }}
                  onClick={() => { showImg(2, item) }}>
                </img>
              </div>
              {
                detailList.map((detailItem, detailIndex) => {
                  return <div key={detailIndex} style={{ wordBreak: 'break-word' }}>{detailItem}</div>
                })
              }
              <div className='col_secondary_text'>{item.addtime + ' ' + item.realname}</div>
            </div>
          )
        });
      } else {
        if (info.pointState === 2) {
          info.advice = [<div className='margB12' key={1}>已处理</div>];
        } else {
          info.advice = [<div className='margB12' style={{ color: colorTextPlaceholder }} key={1}>-</div>];
        }
      }
    }
    setLineInfo(info);
  }

  //上一页，下一页
  const changeInfo = (text) => {
    if (insIdDataListIds.length > 1) {
      insIdDataListIds.forEach((res, index) => {
        if (res.pointId === lineInfo.id) {
          if (text === 'next') {
            if (index === insIdDataListIds.length - 1) {
              // getInfoByPoint(insIdDataListIds[index]);
              return;
            }
            getInfoByPoint(insIdDataListIds[index + 1]);
            setCurrentIndex(index + 1);
            setPointOrder(insIdDataListIds[index + 1]?.point_order)
          }
          if (text === 'last') {
            getInfoByPoint(insIdDataListIds[index - 1]);
            setCurrentIndex(index - 1);
            setPointOrder(insIdDataListIds[index - 1]?.point_order)
          }
        }
      })
    }
  }

  //关闭抽屉
  const closeDrawer = () => {
    setDisable(true);
    setDrawerOpen(false);
    setSelectedKeys([]);
    setTreeData([]);
    setSelectedData([]);
  }

  //关闭处理填报抽屉
  const closeDrawerHandle = () => {
    handleForm.resetFields();
    setChooseFile([]);
    setDrawerHandleOpen(false);
  }

  const goToEarth = () => {
    const coordinate = {
      picUrl: lineInfo.picUrl,
      longitude: lineInfo.longitude, //经度
      latitude: lineInfo.latitude, //纬度
    }
    let d = transformGCJ2WGS({ lat: coordinate.latitude, lon: coordinate.longitude });
    coordinate.latitude = Number(parseFloat(d.lat).toFixed(7));
    coordinate.longitude = Number(parseFloat(d.lon).toFixed(7));
    window.sessionStorage.setItem('PatrolMap?id=' + lineInfo.id, JSON.stringify(coordinate))
    window.open(basicPath + '/PatrolMap?id=' + lineInfo.id, '_blank')
  }

  //搜索处理人员
  const SearchUser = () => ({
    filterDropdown: () => (
      <div style={{ padding: 8, }}>
        <Input
          placeholder='请输入处理人员'
          value={searchUser}
          onChange={(e) => { setSearchUser(e.target.value) }}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>

          <Button
            onClick={() => { setSearchUser('') }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
  });

  //表格单选||多选
  const rowSelection = {
    type: 'checkbox',//单选或多选
    onChange: (selectedRowKeys, selectedRows) => {
      setChooseUser(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.name,
    }),
    defaultSelectedRowKeys: lineInfo.userIds,
  };

  //操作人员表格头
  const user_cil = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: '姓名',
      dataIndex: 'realname',
      ...SearchUser(),
    },
    {
      title: '部门',
      dataIndex: 'department',
    },
    {
      title: '电话',
      dataIndex: 'phone',
    },
  ];

  //获取 处理人员
  const getHandlerList = async () => {
    let params = {
      access_token: token,
      CompanyID: companyId,
    };
    setDrawerLoading(true);
    let res = await getHandlerListFun(params);
    setDrawerLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      return;
    }

    let userIds = lineInfo.userIds;
    let arr = [];
    let keys = [];
    let parent = [];
    for (let i = 0; i < res.data.list.length; i++) { //处理组队的人员
      let val = res.data.list[i];
      parent.push('zd-' + i);
      let obj = {
        title: val.groupname,
        key: 'zd-' + i,
        // eslint-disable-next-line
        children: val.list.map((item, idx) => {
          let text = 'zd-' + i + ':' + item.id;
          if (userIds.indexOf(item.id) >= 0) {
            keys.push(text);
          }
          return {
            title: item.realname,
            key: text,
          }
        })
      };
      arr.push(obj);
    }

    for (let n = 0; n < res.data.other.length; n++) { //处理组队的人员
      let val = res.data.other[n];
      let text = val.id.toString();
      if (userIds.indexOf(text) >= 0) {
        keys.push(text);
      }
      let obj = {
        title: val.realname,
        key: text,
      };
      arr.push(obj);
    }
    keys = Array.from(new Set(keys));
    setSelectedKeys(keys);
    setTreeData(arr);
    setOpenParentKey(parent);
  }

  //提交分配人员
  const submitAllocation = async () => {
    let ids = [];
    let names = [];
    if (selectedData.length > 0) {
      for (let i = 0; i < selectedData.length; i++) {
        let val = selectedData[i];
        if (val.key.indexOf('zd') < 0 || val.key.indexOf(':') >= 0) {
          if (val.key.indexOf('zd') < 0) { //没有分组的 人员
            ids.push(val.key);
          } else { //分组人员
            ids.push(val.key.split(':')[1]);
          }
          names.push(val.title);
        }
      }
    } else {
      for (let i = 0; i < selectedKeys.length; i++) {
        let val = selectedKeys[i];
        if (val.indexOf('zd') < 0 || val.indexOf(':') >= 0) {
          if (val.indexOf('zd') < 0) { //没有分组的 人员
            ids.push(val);
          } else { //分组人员
            ids.push(val.split(':')[1]);
          }
        }
      }
    }

    ids = Array.from(new Set(ids));
    names = Array.from(new Set(names));

    let param = {
      access_token: token,
      companyId: companyId,
      pointId: lineInfo.id,
      handler_user: ids.join(','),
    }
    setDrawerLoading(true);
    let res = await AllocationUser(param);
    setDrawerLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      return;
    }
    message.success(res.msg || '分配人员成功');
    let info = { ...lineInfo };
    info.userName = names;
    info.userIds = ids.join(',');
    setLineInfo(info);
    closeDrawer();

  }

  //忽略
  const IgnorePoint = async () => {
    let param = {
      access_token: token,
      statid: state.statid,
      pointId: lineInfo.id,
    }
    let res = await IgnorePointFun(param);
    if (res.ret !== 200) {
      message.success(res.msg || '数据跑丢了~');
      return;
    }
    if (currentIndex === insIdDataListIds.length - 1) {
      message.success('风险处理完成，即将返回');
      setTimeout(() => {
        switch (state.transfer.urlType) {
          case 1:
            navigate('/routine_risk_conduit', { state: { search: state.transfer } });
            break;
          case 7:
            navigate('/routine_risk_powerGrid', { state: { search: state.transfer } });
            break;
          case 8:
            navigate('/fixedPoint_risk_electricTower', { state: { search: state.transfer } });
            break;
          case 9:
            navigate('/fixedPoint_risk_station', { state: { search: state.transfer } });
            break;

          default:
            break;
        }
      }, 2000)
      return;
    }
    message.success(res.msg || '节点已忽略');
    changeInfo('next');
  }

  //阶段填报
  const stageFill = async (info) => {
    let files = chooseFile.length > 0 ? chooseFile.map((item) => {
      return item.response
    }) : [];
    let params = {
      access_token: token,
      pointId: lineInfo.id,
      status: statusRef.current,
    }
    if (statusRef.current === 1) { //处理完毕
      if (handleForm.getFieldValue('situation')) { //处理情况存在
        let params2 = {
          access_token: token,
          pointId: lineInfo.id,
          status: statusRef.current,
        }
        params2.detail = handleForm.getFieldValue('situation');
        params2.pics = files.join(',');
        params2.status = 0;
        setDrawerHandleLoading(true);
        let res2 = await stageFillFun(params2);
        if (res2.ret !== 200) {
          setDrawerHandleLoading(false);
          message.warning(res2.msg || '数据跑丢了~');
          return;
        }
      }
    }
    if (statusRef.current === 0) {
      params.detail = info.situation;
      params.pics = files.join(',');
    }
    setDrawerHandleLoading(true);
    let res = await stageFillFun(params);
    setDrawerHandleLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      return;
    }
    closeDrawerHandle();
    getInfoByPoint({
      statid: state.statid,
      pointId: lineInfo.id,
    });
  }

  useEffect(() => {
    GetRiskDisposePicFun();
    //eslint-disable-next-line
  }, [])

  return (
    <div>
      {/* <Spin spinning={loading} style={{ display: 'none' }}> */}
      <div className='pdRL24' >
        <div className='marTB16 h40 flex_row align_center' style={{ color: colorText }}>
          <div className='pointer' onClick={() => {
            switch (state.transfer.urlType) {
              case 1:
                navigate('/routine_risk_conduit', { state: { search: state.transfer } });
                break;
              case 7:
                navigate('/routine_risk_powerGrid', { state: { search: state.transfer } });
                break;
              case 8:
                navigate('/fixedPoint_risk_electricTower', { state: { search: state.transfer } });
                break;
              case 9:
                navigate('/fixedPoint_risk_station', { state: { search: state.transfer } });
                break;

              default:
                break;
            }
          }}>
            <ArrowLeftOutlined className="marR16" />
          </div>
          <div className='fs20 fw500 lh28'>
            常规风险处理 - {lineName}
          </div>
          <div className='flex_auto'></div>
          <div style={{ display: infoDataList.handler_status === 2 || !insIdDataList.length ? 'none' : 'block', }}>
            <img src={hourglass} alt="风险数量图标" className='w20 h20 marR4'></img>
            <Badge style={{ color: '#fff' }} count={insIdDataList.length} />
          </div>
        </div>

        <div className='flex_row marB24'>
          <>
            {
              lineInfo.picUrl
                ? (
                  <div className='flex_auto pos_rel'>
                    <img alt="风险" src={lineInfo.picUrl ? lineInfo.picUrl : imgError} className='pointer' style={{ width: '100%' }}
                      onClick={() => { setVisible(true) }}>
                    </img>
                    <Image
                      width={200} style={{ display: 'none', }}
                      src={lineInfo.picUrl}
                      preview={{
                        visible, src: lineInfo.picUrl,
                        onVisibleChange: (value) => { setVisible(value); }
                      }}
                    />
                  </div>
                )
                : (
                  <div className='wid100 flex jcc align_center'
                    style={{
                      height: 'calc(100vh - 144px)',
                      backgroundColor: loading ? '#141414' : "#141414"
                    }}
                  >
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </div>

                )

            }
          </>

          {/* 风险处理右侧信息栏 */}
          <div className='flex_col marL12 w240'>
            <Card style={{ width: 240, border: 0 }} styles={{ body: { padding: 0 } }} >
              <div className="flex_col pdTB16 pdRL24" style={{ borderBottom: '1px solid ' + colorBorderSecondary }}>
                <div
                  className='fw500 fs14 lh22'
                >
                  <span
                    className='pointer'
                    style={{ color: '#177DDC' }}
                    onClick={() => { goToEarth() }}
                  >
                    {lineInfo.address}
                  </span>
                </div>
                <div className='flex align_center'>
                  <span className='marR4 fw500 fs14 lh22' style={{ color: colorTextTertiary }}>
                    {pointOrder}

                  </span>
                </div>
                <span className='fw400 fs14 lh22' style={{ color: colorTextTertiary }}>
                  {lineInfo.date}
                </span>
              </div>


              <div
                className='pdTB10 pdRL16 flex justify_between'
                style={{ borderBottom: '1px solid ' + colorBorderSecondary }}
              >
                <Button disabled={currentIndex === 0} onClick={() => { changeInfo('last') }}> 上一张 </Button>
                <Button disabled={currentIndex === (insIdDataList.length - 1)} onClick={() => { changeInfo('next') }}> 下一张 </Button>
              </div>


              <div className="flex_col mar16">
                <div className='marB12 col_divider_w_btm' style={{ borderBottom: '1px solid ' + colorBorderSecondary }}>
                  <div className='col_secondary_text'> 风险初判 </div>
                  <div className='flex_row flex_wrap marB4'>
                    {
                      lineInfo.divrisk.length > 0 ? lineInfo.divrisk.map((item, idx) => {
                        return <Tag key={idx} color="error" className='marR8 marB8'>{item}</Tag>
                      }) : <div className='marB8' style={{ color: colorTextPlaceholder }}>-</div>
                    }
                  </div>
                </div>

                {/* 处理人员 */}
                <div className='marB12 pdB12' style={{ borderBottom: '1px solid ' + colorBorderSecondary }}>
                  <div className='flex_row'>
                    <div className='col_secondary_text marR8'>处理人员</div>
                    <div className='pointer col_primary' onClick={() => {
                      getHandlerList();
                      setDrawerOpen(true);
                    }}
                    >
                      <UserSwitchOutlined style={{ display: is_handle && (lineInfo.pointState === 1 || lineInfo.pointState === 0) && lineInfo.userName.length > 0 ? '' : 'none' }} />
                      <UserAddOutlined style={{ display: is_handle && (lineInfo.pointState === 1 || lineInfo.pointState === 0) && lineInfo.userName.length === 0 ? '' : 'none' }} />
                    </div>
                  </div>
                  <div className='flex_row flex_wrap'>
                    {
                      lineInfo.userName.length > 0 ?
                        <div>{lineInfo.userName.join('、')}</div>
                        : <div className='marB8' style={{ color: colorTextPlaceholder }}>-</div>
                    }
                  </div>
                </div>

                {/* 处理意见 */}
                <div>
                  <div className='col_secondary_text marB12'> 处理意见 </div>
                  <div className='flex_col'>
                    {lineInfo.advice}
                  </div>
                </div>


                <div className='flex_row'>
                  {/* 忽略 */}
                  <Button type="primary" className='marR12' style={{ display: is_handle && ((lineInfo.pointState === 1 || lineInfo.pointState === 0) && lineInfo.userName.length === 0) ? 'block' : 'none' }}
                    onClick={() => {
                      IgnorePoint();
                    }}>忽略</Button>

                  <Button style={{ display: is_handle && riskStatus !== 1 ? 'block' : 'none' }} type="primary" ghost onClick={() => {
                    setDrawerHandleOpen(true);
                  }}>阶段填报</Button>
                </div>
              </div>


            </Card>
            <div className='flex_auto'></div>
          </div>
        </div >
      </div >

      {/* 分配人员 */}
      <Drawer
        title="处理人员"
        width={265}
        placement="right"
        open={drawerOpen}
        onClose={closeDrawer}
        destroyOnClose={true}
        extra={
          <Space>
            <Button onClick={submitAllocation} type="primary" disabled={disable}>
              提交
            </Button>
          </Space>
        }
      >
        <Spin spinning={drawerLoading}>
          <Tree
            checkable
            expandedKeys={openParentKey}
            style={{ background: '#1F1F1F' }}
            onExpand={(e) => {
              setOpenParentKey(e);
            }}
            onCheck={(e, e2) => {
              setSelectedKeys(e);
              setSelectedData([...e2.checkedNodes]);
              setDisable(false);
            }}
            checkedKeys={selectedKeys}
            treeData={treeData}
          />
        </Spin>
      </Drawer>

      {/* 加载蒙层 */}
      <div className='flex justify_center align_center pos_abs'
        style={{ width: '100%', height: '100%', background: 'rgba(0,0,0,0.4)', top: 0, left: 0, display: loading ? '' : 'none' }}>
        <Spin />
      </div>

      {/* 图片放大 */}
      <AntImage.PreviewGroup
        preview={{
          visible: showImgInfo.visible,
          current: showImgInfo.current,
          onVisibleChange: (value) => {
            let info = { ...showImgInfo };
            info.visible = false;
            info.urls = [];
            info.current = 0;
            setShowImgInfo(info);
          },
          onChange: (e) => {
            let info = { ...showImgInfo };
            info.current = e;
            setShowImgInfo(info);
          }
        }}
        items={showImgInfo.urls}
      >
      </AntImage.PreviewGroup>

      {/* 处理填报 */}
      <Drawer title="处理填报" width={280} placement="right"
        onClose={closeDrawerHandle} open={drawerHandleOpen} destroyOnClose={true}
        extra={
          <Space>
            <Button onClick={() => {
              statusRef.current = 1;
              stageFill({})
            }} type="primary" >
              处理完毕
            </Button>
          </Space>
        }
      >
        <Spin spinning={drawerHandleLoading}>
          <Form
            form={handleForm}
            layout="vertical"
            onFinish={(e) => {
              stageFill(e)
            }}
          >
            <Form.Item
              label="处理情况"
              name="situation"
              rules={[
                { required: true, message: '请输入处理情况', },
              ]}
            >
              <TextArea placeholder="-" />
            </Form.Item>

            <Form.Item label="添加图片" valuePropName="fileList">
              <Upload
                data={{ pointId: lineInfo.id }} customRequest={async (e) => {
                  let res = await uploadImageFun({
                    access_token: token,
                    pointId: lineInfo.id,
                    file: e.file
                  });
                  if (res.ret !== 200) {
                    message.warning(res.msg || '数据跑丢了~');
                    return;
                  }
                  return e.onSuccess(res.data)
                }} listType="picture-card" maxCount={3}
                onChange={(e) => {
                  setChooseFile(e.fileList);
                }}
              >
                {
                  chooseFile.length >= 3 ? null :
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8, }}  >
                        Upload
                      </div>
                    </div>
                }

              </Upload>
            </Form.Item>

            <Form.Item>
              <Button type="primary" ghost onClick={() => {
                statusRef.current = 0;
                handleForm.submit();
              }}>
                阶段填报
              </Button>
            </Form.Item>
          </Form>

        </Spin>
      </Drawer>
    </div >
  )
}
export default ConventionalRisksHandle